module.exports = __webpack_public_path__ + "img/u942.925cbfe3.png";